import querystring from 'querystring';
import { ContextURL } from './ContextURL';
import { Editor, Platform } from './types';
export class ContextProviderImpl {
  mapArea(parentUrl) {
    // phase 1 - area mapping hardcoded in the widget
    // phase 2 - area mapping can be adjusted in our backoffice, we fetch it from our API
    const areaMapping = {
      '/dashboard/': 'dashboard',
      'https://editor.wix.com/html/editor/': 'editor',
      'https://create.editorx.com/html/editor/': 'editorx',
      'https://editor.wix.com/website/builder': 'adi',
      '/account/sites/': 'mysites',
      '/studio/sites': 'mysites',
      '/account/': 'accountLevel',
      'https://support.wix.com/': 'helpCenter',
      'https://www.wix.com/contact': 'contact'
    };
    const urls = Object.keys(areaMapping);
    const areaUrl = urls.find(url => (parentUrl || window.location.href).includes(url)) || '';
    return areaMapping[areaUrl] || 'unknown';
  }
  getMetaSiteId(queryParams) {
    if (queryParams != null && queryParams.metaSiteId) {
      return queryParams.metaSiteId;
    }
    const uuidRegex = new RegExp(/\b[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-\b[0-9a-fA-F]{12}\b/);
    const dashboardRegex = new RegExp(/dashboard\//);
    const urlRegex = new RegExp(dashboardRegex.source + uuidRegex.source);
    const match = window.location.href.match(urlRegex);
    if (match != null && match.length) {
      const uuidMatch = match[0].match(uuidRegex);
      return uuidMatch != null && uuidMatch.length ? uuidMatch[0] : '';
    }
    return '';
  }
  getHelpCenterSpecificContext() {
    return {
      articleName: '',
      articleId: '',
      articleType: '',
      articleEditor: Editor.UNKNOWN,
      pageType: '',
      categoryId: ''
    };
  }
  getMappingUrl(contextUrl) {
    return contextUrl.getCleanPathname() ?? '';
  }
  getMappingProduct(contextUrl) {
    return contextUrl.getProduct() ?? '';
  }
  getPage() {
    var _window$location$path, _window$location$sear;
    // remove the first slash to avoid empty first element
    const urlChunks = (_window$location$path = window.location.pathname) == null || (_window$location$path = _window$location$path.substring(1).split('/')) == null ? void 0 : _window$location$path.filter(String);
    const parsedQueryParams = querystring.parse((_window$location$sear = window.location.search) == null ? void 0 : _window$location$sear.substring(1));
    // parse non string values into strings to avoid rpc errors
    const queryParams = Object.keys(parsedQueryParams).reduce((acc, key) => {
      acc[key] = String(parsedQueryParams[key]);
      return acc;
    }, {});
    return {
      numLevels: urlChunks == null ? void 0 : urlChunks.length,
      urlChunks,
      topLevelRoute: urlChunks[0],
      queryParams
    };
  }
  getMinimalContext(parentUrl) {
    const contextUrl = new ContextURL(window.location.href);
    const page = this.getPage();
    return {
      domain: window.location.hostname,
      area: this.mapArea(parentUrl),
      page,
      metaSiteId: this.getMetaSiteId(page.queryParams),
      parentUrl: parentUrl || window.location.href.split('?')[0],
      helpCenterSpecificContext: this.getHelpCenterSpecificContext(),
      mappingUrl: this.getMappingUrl(contextUrl),
      mappingProduct: this.getMappingProduct(contextUrl)
    };
  }
  getContext(_ref, parentUrl) {
    let userId = _ref.userId,
      accountId = _ref.accountId,
      userExperience = _ref.userExperience,
      careProfile = _ref.careProfile,
      isMobile = _ref.isMobile,
      isWidget = _ref.isWidget;
    return Promise.resolve({
      ...this.getMinimalContext(parentUrl),
      platform: isMobile ? Platform.MOBILE : Platform.DESKTOP,
      userId,
      accountId,
      userExperience,
      careProfile,
      isWidget: typeof isWidget === 'boolean' ? isWidget : true
      // TODO: remove typecast(`userId` is required in Context, but it's optional in ExtraParams!)
    });
  }
}
export const contextProvider = new ContextProviderImpl();
//# sourceMappingURL=ContextProvider.js.map